<template>
  <el-dialog
    :title="editForm.id==null||editForm==''? pileType == 'Q' ? '登记汽车桩费率':'登记电单车桩费率':pileType == 'Q'?'编辑汽车桩费率':'编辑电单车桩费率'"
    :visible="editFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="editForm.id!=null&&editForm!=''"
    :modal-append-to-body='false'
    :before-close="clearEditForm">
    <el-form :model="editForm" ref="editForm" size="mini" class="edit_form" :rules="editFormRules">
      <el-row>
        <el-col :span="10">
          <el-form-item label="费率名称" :label-width="formLabelWidth" class=“required” prop="ruleName">
            <el-input size="mini" autocomplete="off" placeholder="请填写" v-model="editForm.ruleName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="运营商" :label-width="formLabelWidth" prop="operatorId">
 <!--           <el-select placeholder="运营商" v-model="editForm.operatorId">
              <el-option v-for="item in operatorForSelect" :key="item.id" :disabled="operatorDisable(item)"
                         v-bind:label="item.name" v-bind:value="item.id"></el-option>
            </el-select>-->
            <el-cascader  size="mini" ref="cascader"
                          placeholder="运营商"  filterable
                          :options="this.setTreeDisable(this.operatorForSelect)"
                          :props="{ checkStrictly:true,expandTrigger:'hover'}"
                          :show-all-levels="false"
                          change-on-select
                          @change='handleChangeOperator'
                          v-model="editForm.operatorId">
            </el-cascader>
          </el-form-item>
        </el-col>
        <el-col v-show="pileType == 'Q'"  :span="10">
          <el-form-item label="预约计费/次" :label-width="formLabelWidth" prop="appointmentPrice">
            <el-input size="mini" autocomplete="off" placeholder="元/次"
                      v-model="editForm.appointmentPrice"></el-input>
          </el-form-item>
        </el-col>
        <el-col v-show="pileType == 'Q'" :span="10">
          <el-form-item label="预约时长/毫秒" :label-width="formLabelWidth" prop="appointmentTimes">
            <el-input size="mini" autocomplete="off" placeholder="毫秒"
                      v-model="editForm.appointmentTimes"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="折扣率" :label-width="formLabelWidth" prop="discountRate">
            <el-input size="mini" autocomplete="off" placeholder="填写大于或等于0且小于1的数字" v-model="editForm.discountRate"></el-input>
          </el-form-item>
        </el-col>
        <el-col v-show="pileType == 'Q'" :span="10">
          <el-form-item label="电损率" :label-width="formLabelWidth" prop="electricLossRate">
            <el-input size="mini" autocomplete="off" placeholder="填写大于或等于0且小于1的数字"
                      v-model="editForm.electricLossRate"></el-input>
          </el-form-item>
        </el-col>
        <el-col v-show="pileType == 'Q'" :span="10">
          <el-form-item label="显示电损比率" :label-width="formLabelWidth" prop="showElectricLossRate">
            <el-select placeholder="移动端是否显示电损比率" v-model="editForm.showElectricLossRate">
              <el-option v-for="item in YesNoEnumData" :key="item.value"
                         v-bind:label="item.message" v-bind:value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-divider content-position="left">
        <el-radio v-model="editForm.type" label="standard" @change="standardInputChange">
          启用标准服务计划规则
        </el-radio>
      </el-divider>
      <el-row>
        <el-col v-show="pileType == 'Q'" :span="10">
          <el-form-item label="标准电费" :label-width="formLabelWidth" prop="standardElectricityFees">
            <el-input size="mini" autocomplete="off" placeholder="元/kW·h" v-model="editForm.standardElectricityFees"
                      v-bind:disabled="standardAble">元/kW·h
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="标准服务费" :label-width="formLabelWidth" prop="standardServiceFees">
            <el-input size="mini" autocomplete="off" :placeholder="pileType == 'Q'?'元/kW·h':'元/分钟'" v-model="editForm.standardServiceFees"
                      v-bind:disabled="standardAble">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-divider content-position="left">
        <el-radio v-model="editForm.type"  label="times"  @change="timesInputChange">
          <span v-html="pileType == 'Q'? '启用分时服务计费规则（注:本规则启动后【标准电费】无效，设置必须完整覆盖全天时间区段）' : '启用功率阶梯计费规则（注:本规则启动后【标准电费】无效）' "></span>
        </el-radio>
      </el-divider>
      <el-row type="flex" :gutter="6" style="margin-top: 20px;" justify="space-between">
        <el-col :span="5"  class="el_col_one"><span style="color: #409EFF;" class="span_one">●</span><span v-html="pileType == 'Q'?'尖 时 电 费':'第一阶段功率' "></span>
          <el-form-item prop="topElectricityFees">
            <el-input size="mini" autocomplete="off" :placeholder="pileType == 'Q'?'元/kW·h':'W'" style="margin-top: 16px;"
                      v-model="editForm.topElectricityFees" v-bind:disabled="timesAble"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5" class="el_col_one"><span style="color:  #43c26e" class="span_one">●</span><span v-html="pileType == 'Q'?'峰 时 电 费':'第二阶段功率' "></span>
          <el-form-item prop="summitElectricityFees">
            <el-input size="mini" autocomplete="off" :placeholder="pileType == 'Q'?'元/kW·h':'W'" style="margin-top: 16px;"
                      v-model="editForm.summitElectricityFees" v-bind:disabled="timesAble"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5" class="el_col_one"><span style="color: #ff4d4d" class="span_one">●</span><span v-html="pileType == 'Q'?'平 时 电 费':'第三阶段功率' "></span>
          <el-form-item prop="flatElectricityFees">
            <el-input size="mini" autocomplete="off" :placeholder="pileType == 'Q'?'元/kW·h':'W'" style="margin-top: 16px;"
                      v-model="editForm.flatElectricityFees" v-bind:disabled="timesAble"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5" class="el_col_one"><span style="color: #ffbc2e" class="span_one">●</span><span v-html="pileType == 'Q'?'谷 时 电 费':'往后阶段功率' "></span>
          <el-form-item prop="valleyElectricityFees">
            <el-input size="mini" autocomplete="off" :placeholder="pileType == 'Q'?'元/kW·h':'W'" style="margin-top: 16px;"
                      v-model="editForm.valleyElectricityFees" v-bind:disabled="timesAble"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex" :gutter="6" style="margin-top: 20px;" justify="space-between">
        <el-col :span="5" class="el_col_one"><span style="color: #409EFF;" class="span_one">●</span><span v-html="pileType == 'Q'?'尖 时 服 务 费':'第一阶段服务费' "></span>
          <el-form-item prop="topServiceFees">
            <el-input size="mini" autocomplete="off" :placeholder="pileType == 'Q'?'元/kW·h':'元/分钟'" style="margin-top: 16px;"
                      v-model="editForm.topServiceFees" v-bind:disabled="timesAble"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5" class="el_col_one"><span style="color:  #43c26e" class="span_one">●</span><span v-html="pileType == 'Q'?'峰 时 服 务 费':'第二阶段服务费' "></span>
          <el-form-item prop="summitServiceFees">
            <el-input size="mini" autocomplete="off" :placeholder="pileType == 'Q'?'元/kW·h':'元/分钟'" style="margin-top: 16px;"
                      v-model="editForm.summitServiceFees" v-bind:disabled="timesAble"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5" class="el_col_one"><span style="color: #ff4d4d" class="span_one">●</span><span v-html="pileType == 'Q'?'平 时 服 务 费':'第三阶段服务费' "></span>
          <el-form-item prop="flatServiceFees">
            <el-input size="mini" autocomplete="off" :placeholder="pileType == 'Q'?'元/kW·h':'元/分钟'" style="margin-top: 16px;"
                      v-model="editForm.flatServiceFees" v-bind:disabled="timesAble"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5" class="el_col_one"><span style="color: #ffbc2e" class="span_one">●</span><span v-html="pileType == 'Q'?'谷 时 服 务 费':'往后阶段服务费' "></span>
          <el-form-item prop="valleyServiceFees">
            <el-input size="mini" autocomplete="off" :placeholder="pileType == 'Q'?'元/kW·h':'元/分钟'" style="margin-top: 16px;"
                      v-model="editForm.valleyServiceFees" v-bind:disabled="timesAble"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-divider v-if="pileType == 'Q'" content-position="left" style="padding-top: 20px;"><i class="el-icon-caret-right"></i>
        先选择时段标志，再点击时段设置
      </el-divider>
      <el-row v-show="pileType == 'Q'" :gutter="8">
        <el-col :span="6">
          <el-button type="primary" round plain size="mini" @click="topCheck" :disabled="topCheckFlag">尖时
          </el-button>
        </el-col>
        <el-col :span="6">
          <el-button type="success" round plain size="mini" @click="summitCheck" :disabled="summitCheckFlag">峰时
          </el-button>
        </el-col>
        <el-col :span="6">
          <el-button type="danger" round plain size="mini" @click="flatCheck" :disabled="flatCheckFlag">平时
          </el-button>
        </el-col>
        <el-col :span="6">
          <el-button type="warning" round plain size="mini" @click="valleyCheck" :disabled="valleyCheckFlag">谷时
          </el-button>
        </el-col>
      </el-row>
      <!-- -->
      <el-row v-show="pileType == 'Q'" class="timeLabOut">
        <el-row class="timeLabIn" v-bind:key="i" v-for="(data,i) in tableData">
          <el-col class="timeLabInCol" :span="6" v-bind:key="j" v-for="(dataX, j) in data"
                  @mouseenter.native="timeMouseenter($event)"
                  @mousedown.native="timeMousedown($event)"
                  ref="timeLabInCol">
            <label v-text="dataX"></label>
          </el-col>
        </el-row>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="clearEditForm">取 消</el-button>
      <el-button size="small" type="primary" @click.native="editSubmit" :loading="editSubmitLoading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import {validateInput,verifyDiscountRate} from '../../../../common/validator'
  export default {
    name: "add",
    data(){
      return{
        editFormRules: {
          ruleName: [{required: true, message: '请输入费率名称',trigger: 'blur'},{validator: function (rule, value, callback) {
              validateInput(rule, value, callback,0,12,true,true,false,false,false,false,false)
            }, trigger: 'blur'}],
          operatorId: [{required: true, message: '请选择运营商',trigger: 'blur'}],
          appointmentPrice: [{validator: function (rule, value, callback) {
              validateInput(rule, value, callback,0,12,true,false,false,false,false,false,true)
            }, trigger: 'blur'}],
          appointmentTimes: [{validator: function (rule, value, callback) {
              validateInput(rule, value, callback,0,12,true,true,true,true,false,false,false)
            }, trigger: 'blur'}],
          discountRate: [{required: true, message: '请输入折扣率',trigger: 'blur'}, {validator: verifyDiscountRate, trigger: 'blur'}],
          electricLossRate:[{required: true, message: '请输入电损率',trigger: 'blur'}, {validator: verifyDiscountRate, trigger: 'blur'}],
          standardElectricityFees:[{validator: function (rule, value, callback) {
              validateInput(rule, value, callback,0,12,true,false,false,false,false,false,true)
            }, trigger: 'blur'}],
          standardServiceFees:[{validator: function (rule, value, callback) {
              validateInput(rule, value, callback,0,12,true,false,false,false,false,false,true)
            }, trigger: 'blur'}],
          topElectricityFees:[{validator: function (rule, value, callback) {
              validateInput(rule, value, callback,0,12,true,false,false,false,false,false,true)
            }, trigger: 'blur'}],
          summitElectricityFees:[{validator: function (rule, value, callback) {
              validateInput(rule, value, callback,0,12,true,false,false,false,false,false,true)
            }, trigger: 'blur'}],
          flatElectricityFees:[{validator: function (rule, value, callback) {
              validateInput(rule, value, callback,0,12,true,false,false,false,false,false,true)
            }, trigger: 'blur'}],
          valleyElectricityFees:[{validator: function (rule, value, callback) {
              validateInput(rule, value, callback,0,12,true,false,false,false,false,false,true)
            }, trigger: 'blur'}],
          topServiceFees:[{validator: function (rule, value, callback) {
              validateInput(rule, value, callback,0,12,true,false,false,false,false,false,true)
            }, trigger: 'blur'}],
          summitServiceFees:[{validator: function (rule, value, callback) {
              validateInput(rule, value, callback,0,12,true,false,false,false,false,false,true)
            }, trigger: 'blur'}],
          flatServiceFees:[{validator: function (rule, value, callback) {
              validateInput(rule, value, callback,0,12,true,false,false,false,false,false,true)
            }, trigger: 'blur'}],
          valleyServiceFees:[{validator: function (rule, value, callback) {
              validateInput(rule, value, callback,0,12,true,false,false,false,false,false,true)
            }, trigger: 'blur'}]
        },
        formLabelWidth: '120px',
      }
    },
    props:{
      editForm:{},
      editFormVisible:false,
      operatorForSelect:{},
      standardAble:false,
      editSubmitLoading:false,
      tableData:"",
      timesAble:"",
      topCheckFlag:"",
      summitCheckFlag:"",
      flatCheckFlag:"",
      valleyCheckFlag:"",
      YesNoEnumData:'',
      pileType: ''
    },
    methods:{
      operatorDisable(item) {
        // 判断是否为潜在运营商
        const flag = (item.checked && (item.checked === 'unchecked' || item.checked === 'unapproved')) ? true : false
        return flag
      },
      //对数据进行授权过滤
      setTreeDisable(val) {
        //对 treeList 进行递归操作，禁止选中unchecked和unapproved
        val && val.forEach(item => {
          if ((item.checked && (item.checked === 'unchecked' || item.checked === 'unapproved'))) {
            item.disabled = true; // 如果类型为unchecked或者unapproved，就增加禁用选项
          }
          if (item.children) {
            this.setTreeDisable(item.children);
          }
        });
        return val;
      },
      handleChangeOperator(value) {
        let operatorId = value &&value.length >0 ? value[value.length-1] : ''
        this.editForm.operatorId= operatorId
        this.$refs.cascader.dropDownVisible = false
      },
      clearEditForm(){
        let _this = this
        console.log(this.editForm.id)
        if(this.editForm.id == null || this.editForm == '') {
          this.$confirm('是否要取消当前操作？').then(_ => {
            _this.$refs.editForm.clearValidate()
            _this.$emit('closeEditForm')
          }).catch(_ => {})
        }else {
          _this.$refs.editForm.clearValidate()
          _this.$emit('closeEditForm')
        }
      },
      editSubmit(){
        this.editForm.pileType= this.pileType;
        this.$emit("editSubmit", this.$refs.editForm)
      },
      timeMouseenter(event){
        this.$emit("timeMouseenter",event)
      },
      timeMousedown(event){
        this.$emit("timeMousedown",event)
      },
      topCheck(){
        this.$emit("topCheck")
      },
      summitCheck(){
        this.$emit("summitCheck")
      },
      flatCheck(){
        this.$emit("flatCheck")
      },
      valleyCheck(){
        this.$emit("valleyCheck")
      },
      standardInputChange(){
        this.$emit("standardInputChange")
      },
      timesInputChange(){
        this.$emit("timesInputChange")
      },
    }
  }
</script>

<style lang="less" scoped>
  /deep/ .edit_form {
    .el-form-item__content {
      .el-input {
        width: 210px;
      }
    }
  }

  .timeLabOut {
    margin-top: 20px;
    user-select: none;
    border-left: 1px solid rgba(0, 0, 0, 0.2);
    border-top: 1px solid rgba(0, 0, 0, 0.2);
  }

  .timeLabIn {
    user-select: none;
    width: 100%;
    line-height: 40px;
  }

  .timeLabInCol {
    user-select: none;
    border-right: 1px solid rgba(0, 0, 0, 0.2);
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  }

  .topCheck {
    background-color: rgba(64, 158, 255, 0.6);
  }

  .summitCheck {
    background-color: rgba(103, 194, 58, 0.6);
  }

  .flatCheck {
    background-color: rgba(245, 108, 108, 0.6);
  }

  .valleyCheck {
    background-color: rgba(230, 162, 60, 0.6);
  }
</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/rateManager/add.vue